import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { GRID_CONSTANTS } from '@go-modules/components/grid-virtual-scroll-viewport/grid.constants';
import { ArchivedListDataSource } from '@go-modules/services/archive';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
	selector: 'archive-grid-view',
	templateUrl: './archive-grid-view.component.html',
	styleUrls: ['./archive-grid-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NgxArchiveGridViewComponent implements OnInit, OnDestroy {
	public minWidth: number = GRID_CONSTANTS.minWidth;
	public maxWidth: number = GRID_CONSTANTS.maxWidth;
	public minGap: number = GRID_CONSTANTS.minGap;
	private readonly componentDestroyed$ = new Subject<void>();

	constructor (public archiveListDataSource: ArchivedListDataSource) {}

	public ngOnInit () {
		this.archiveListDataSource.onScrollLimit$.pipe(takeUntil(this.componentDestroyed$)).subscribe();
	}

	public ngOnDestroy (): void {
		this.componentDestroyed$.next();
		this.componentDestroyed$.complete();
	}
}
